import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { RecuperableModelError } from "@iot-platform/core";
import type { NotificationAlertRepository } from "@station/domain/repositories/notification-alert.repository";
import { stationsTypes } from "@station/station-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotificationAlertDeleteUseCase {
    constructor(
        @inject(stationsTypes.repositories.NotificationAlertRepository)
        private readonly notificationAlertRepository: NotificationAlertRepository,
    ) {}

    async execute(notificationAlertId: string): Promise<boolean> {
        const editResult =
            await this.notificationAlertRepository.delete(notificationAlertId);

        return editResult.match(
            () => true,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return false;
                }

                ToastManagerRepository.error(error.message);

                return false;
            },
        );
    }
}
